import { Routes } from '@angular/router';
import { HandoverLogsComponent } from './components/handover-logs/handover-logs.component';
import { HomeComponent } from './components/home/home.component';
import { ShiftLogsComponent } from './components/shift-logs/shift-logs.component';
import { HighAlertsComponent } from './components/high-alerts/high-alerts.component';
import { RoutesName } from './shared/constants/routes-name';
import { WorldClockComponent } from './components/world-clock/world-clock.component';
import { InitialDataResolver } from './core/initial-data.resolver';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';

export const routes: Routes = [
  { path: RoutesName.FORBIDDEN, component: ForbiddenComponent, title: 'Access denied' },
  {
    path: '',
    resolve: { init: InitialDataResolver },
    component: HomeComponent,
    title: 'DR OPS Stream UI',
    children: [
      { path: '', redirectTo: 'handover-log', pathMatch: 'full' },
      {
        path: RoutesName.HANDOVER_LOG,
        component: HandoverLogsComponent,
        title: 'Handover Log',
      },
      {
        path: RoutesName.SHIFT_LOG,
        component: ShiftLogsComponent,
        title: 'Shift Log',
      },
      {
        path: RoutesName.HIGH_ALERTS,
        component: HighAlertsComponent,
        title: 'High Alerts',
      },
      {
        path: RoutesName.WORLD_CLOCK,
        component: WorldClockComponent,
        title: 'World Clock',
      },
    ],
  },
];
